import { NgModule } from '@angular/core';
import { DossierEditorsPipe } from '@dossier/shared/pipes/dossier-editors.pipe';
import { DossierNewVersionPipe } from '@dossier/shared/pipes/dossier-new-version.pipe';
import { SubPathNumberPipe } from '@dossier/shared/pipes/sub-path-number.pipe';
import { WeekDaysTextPipe } from '@dossier/shared/pipes/week-days-text.pipe';

@NgModule({
  declarations: [
    WeekDaysTextPipe,
    SubPathNumberPipe,
    DossierEditorsPipe,
    DossierNewVersionPipe
  ],
  exports: [
    WeekDaysTextPipe,
    SubPathNumberPipe,
    DossierEditorsPipe,
    DossierNewVersionPipe
  ]
})
export class DossierPipesModule {
}
